
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotell/[countryLevel1]",
      function () {
        return require("private-next-pages/hotell/[countryLevel1].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotell/[countryLevel1]"])
      });
    }
  